import { useTranslation } from "react-i18next";
import { store } from "..";
import { sendEvents } from "../../analytics/eventWrapper";
import { CLEVERTAP_EVENTS } from "../../analytics/trackerEvents/cleverTap/events";
import { CT_PARAMS } from "../../analytics/trackerEvents/cleverTap/parameters";
import { emit } from "../../classes/socket/gameplay";
import { BOARD_CONFIG, TWO_PLAYER_CONFIG } from "../../components/GamePlayComponents/constant";
// import { getShouldShowScoreAnimation } from "../../components/GamePlayComponents/store/actions";
import { calculateCoordinates } from "../../components/GamePlayComponents/utils";
import { parseString } from "../../utils/helpers/common";
import { getWidth } from "../../utils/relativeSizes";
import { LB_HIDE_GAME_END_NUDGE, LB_SHOW_GAME_END_NUDGE, LB_TOGGLE_LAST_MOVE,  } from "../reduxConstants";
import { getMySeatIndex, getSerialNumber, getUserId, getUsername } from "../selectors/ludoboardSelectors";
import { ICoordinates, IKilledKukari, IKukariMoveConfig, IMovingKukari, ISmoke, ITableInfo, NX_HOME_ANIMATION_TYPE, PLAYER_NUMBER, UserProfile } from "../../pages/GamePlay/types";
import { _has, _isEmpty, _isNil, _slice, _startsWith } from "../../utils/helpers/zupeeLodash";
import { LB_FINISH_KILL_USER_TOKEN, LB_FINISH_MOVE_USER_TOKEN, LB_HIDE_GAME_START_NUDGE, LB_HIDE_POINTS_ANIMATION, LB_HIDE_SMOKE_ANIMATION, LB_HIDE_TRIPLE_SIX_ANIMATION, LB_KILL_USER_TOKEN, LB_MOVE_USER_TOKEN, LB_NX_HIDE_KUKARI_SCORE, LB_NX_HIDE_SCORE_REVEAL_ANIMATION, LB_NX_SHOW_KUKARI_SCORE, LB_NX_SHOW_SCORE_REVEAL_ANIMATION, LB_RESET_GAMEPLAY, LB_RESET_SCORE_FLY_ANIMATION_CONFIG, LB_ROUND_TIMER_STARTED, LB_SET_IS_PRIZEPOOL_TOOLTIP_VISIBLE, LB_SET_IS_SKIP_TOOLTIP_VISIBLE, LB_SET_IS_TNC_BS_VISIBLE, LB_SET_KUKARI_MOVE_CONFIG, LB_SET_SCORE_FLY_ANIMATION_CONFIG, LB_SET_SHOW_EXTRA_MOVE_NUDGE, LB_SHOW_GAME_START_NUDGE, LB_SHOW_POINTS_ANIMATION, LB_SHOW_SMOKE_ANIMATION, LB_SHOW_TRIPLE_SIX_ANIMATION, LB_START_BOUNCE_ANIMATION, LB_START_DICE_ANIMATION, LB_START_TIME_BANK_TIMER, LB_STOP_BOUNCE_ANIMATION, LB_STOP_DICE_ANIMATION, LB_STOP_TIME_BANK_TIMER, LB_STOP_TURN_TIMER, LB_TOGGLE_COIN_ANIMATION, LB_UPDATE_PLAYER_SI_MAP, LB_UPDATE_TABLE_INFO, LB_UPDATE_TIME_BANK_TIME_LEFT, LB_USER_PROFILE_FOLLOW, LB_USER_TURN_STARTED } from "../reduxConstants";
import { getBoardType, getPlayersInfo, getShouldShowScoreAnimation } from "../selectors/ludoboardSelectors";

const { dispatch, getState } = store;

export function setPlayerSiMap(playerNumber: PLAYER_NUMBER, seatIndex: number) {
  dispatch({ type: LB_UPDATE_PLAYER_SI_MAP, updates: { [playerNumber]: seatIndex } })
}

export function setKukariMoveConfig(kukariMoveConfig: IKukariMoveConfig) {
  dispatch({ type: LB_SET_KUKARI_MOVE_CONFIG, kukariMoveConfig })
}

export function showKukariScore() {
  return dispatch({
    type: LB_NX_SHOW_KUKARI_SCORE
  });
}

export function hideKukariScore() {
  return dispatch({
    type: LB_NX_HIDE_KUKARI_SCORE
  });
}

export function updateGameTableInfo(data: ITableInfo) {
    console.log("getState", getState())
    
  dispatch({
    type: LB_UPDATE_TABLE_INFO,
    updates: data,
  });
}

export function setRoundTimerStarted(data: { isOpenShareModal?: boolean; gameStartCountdown?: number; startGameIcon?: boolean }) {
  dispatch({
    type: LB_ROUND_TIMER_STARTED,
    data
  })
}

export function setShowExtraMoveNudge(shouldShow: boolean) {
  dispatch({ type: LB_SET_SHOW_EXTRA_MOVE_NUDGE, shouldShow })
}

export function setUTSData(data: any) {
  dispatch({
    type: LB_USER_TURN_STARTED,
    payload: data
  })
}

export function startDiceAnimation() {
  dispatch({ type: LB_START_DICE_ANIMATION })
}

export function stopDiceAnimation() {
  dispatch({ type: LB_STOP_DICE_ANIMATION })
}

export function startBounceAnimation() {
  dispatch({ type: LB_START_BOUNCE_ANIMATION })
}

export function showTripleSixAnimation() {
  dispatch({ type: LB_SHOW_TRIPLE_SIX_ANIMATION })
}

export function hideTripleSixAnimation() {
  dispatch({ type: LB_HIDE_TRIPLE_SIX_ANIMATION })
}


export function stopBounceAnimation() {
  dispatch({ type: LB_STOP_BOUNCE_ANIMATION })
}

export function stopTurnTimer() {
  dispatch({ type: LB_STOP_TURN_TIMER })
}

export function setUserSocialRelationToFollowing(userProfile: UserProfile) {
  dispatch({ type: LB_USER_PROFILE_FOLLOW, userProfile })
}

export function setIsPrizepoolTooltipVisible(isPrizepoolTooltipVisible: boolean) {
  dispatch({ type: LB_SET_IS_PRIZEPOOL_TOOLTIP_VISIBLE, isPrizepoolTooltipVisible })
}

export function setIsTNCBSVisible(isTNCBSVisible: boolean) {
  dispatch({ type: LB_SET_IS_TNC_BS_VISIBLE, isTNCBSVisible })
}

export function startTimeBankTimer(timeBankTimeLeft: number) {
  dispatch({ type: LB_START_TIME_BANK_TIMER, timeBankTimeLeft })
}

export function stopTimeBankTimer(timeBankTimeLeft?: number) {
  dispatch({ type: LB_STOP_TIME_BANK_TIMER, timeBankTimeLeft })
}

export function updateTimeBankTimeLeft(timeBankTimeLeft: number) {
  dispatch({ type: LB_UPDATE_TIME_BANK_TIME_LEFT, timeBankTimeLeft })
}

export function resetGameplayState() {
  dispatch({ type: LB_RESET_GAMEPLAY })
}


export function showScoreRevealAnimation() {
  return dispatch({
    type: LB_NX_SHOW_SCORE_REVEAL_ANIMATION
  });
}

export function hideScoreRevealAnimation() {
  return dispatch({
    type: LB_NX_HIDE_SCORE_REVEAL_ANIMATION
  });
}

export function setIsSkipTooltipVisible(isSkipTooltipVisible: boolean) {
  dispatch({ type: LB_SET_IS_SKIP_TOOLTIP_VISIBLE, isSkipTooltipVisible })
}


export function showSmokeAnimation(smoke: ISmoke) {
  dispatch({
    type: LB_SHOW_SMOKE_ANIMATION,
    smoke
  })
}

export function hideSmokeAnimation() {
  dispatch({
    type: LB_HIDE_SMOKE_ANIMATION
  })
}

export function setKillUserToken(killedKukari: IKilledKukari) {
  dispatch({
    type: LB_KILL_USER_TOKEN,
    killedKukari
  })
}

export function setMoveUserToken(movingKukari: IMovingKukari) {
  dispatch({
    type: LB_MOVE_USER_TOKEN,
    movingKukari
  })
}

export function showHomeAnimationNx(homeCount: number) {
  const lang = localStorage.getItem("language");

  let nxHomeAnimationType = NX_HOME_ANIMATION_TYPE.NICE
  if (homeCount === 1) {
    nxHomeAnimationType = lang === "hi" ? NX_HOME_ANIMATION_TYPE.SHABASH : NX_HOME_ANIMATION_TYPE.NICE
  } else if (homeCount === 2) {
    nxHomeAnimationType = lang === "hi" ? NX_HOME_ANIMATION_TYPE.BAHUT_BADHIYA : NX_HOME_ANIMATION_TYPE.WELL_DONE
  } else {
    nxHomeAnimationType = lang === "hi" ? NX_HOME_ANIMATION_TYPE.JABARDAST : NX_HOME_ANIMATION_TYPE.GREAT_JOB
  }
  dispatch({
    type: LB_SHOW_POINTS_ANIMATION,
    homeAnimationConfig: {
      nxHomeAnimationType
    }
  })

  setTimeout(() => {
    hideHomeAnimation()
  }, 3000)

}

export function hideHomeAnimation() {
  dispatch({
    type: LB_HIDE_POINTS_ANIMATION
  })
}

export function setFinishMoveUserToken(si?: number, ti?: number, fp?: number) {
  let pi = getPlayersInfo(getState())

  if (!_isNil(si) && !_isNil(ti) && !_isNil(fp) && _has(pi, si)) {
    pi = [
      ..._slice(pi, 0, si),
      { ...pi[si], dvp: [..._slice(pi[si].dvp, 0, ti), fp, ..._slice(pi[si].dvp, ti + 1)] },
      ..._slice(pi, si + 1)
    ]
  }

  dispatch({
    type: LB_FINISH_MOVE_USER_TOKEN,
    movingKukari: null,
    pi
  })
}


export function setScoreFlyAnimationConfigForToken(
  playerNumber: PLAYER_NUMBER,
  force: boolean = false,
  finalTokenPosition?: number,
  initialTokenPosition?: number,
  isLudoNx: boolean = false
) {
  const state = getState();
  const shouldShowScoreAnimation = getShouldShowScoreAnimation(playerNumber, state);
  const currentConfig = state.ludoboard.tableInfo.scoreFlyAnimationConfig?.[playerNumber];

  // If there's already an animation in progress for this player, don't start another one
  if (currentConfig) {
    return;
  }

  if (force || shouldShowScoreAnimation) {
    let initialPosition: ICoordinates | null = { translateX: 0, translateY: 0 }
    let score = 56
    if (!_isNil(finalTokenPosition) && !_isNil(initialTokenPosition)) {
      const _pos = calculateCoordinates(playerNumber, finalTokenPosition)
      if (!_isNil(_pos)) {
        score = finalTokenPosition - initialTokenPosition
        if (score < 0) {
          initialPosition = { translateX: _pos.translateX, translateY: _pos.translateY + getWidth(-32) }
        } else {
          initialPosition = { translateX: _pos.translateX, translateY: _pos.translateY + getWidth(-50) }
        }
      } else {
        initialPosition = null
      }
    }

    const finalPosition = { translateX: getWidth(50), translateY: -getWidth(280) }

    if (!_isNil(initialPosition) && !_isNil(finalPosition)) {
      dispatch({
        type: LB_SET_SCORE_FLY_ANIMATION_CONFIG,
        scoreFlyAnimationConfig: { initialPosition, finalPosition, playerNumber: isLudoNx ? PLAYER_NUMBER.ONE : playerNumber, score }
      })
    }
  }
}

export function setFinishKillUserToken(si?: number, ti?: number, fp?: number) {
  let pi = getPlayersInfo(getState())

  if (!_isNil(si) && !_isNil(ti) && !_isNil(fp) && _has(pi, si)) {
    pi = [
      ..._slice(pi, 0, si),
      { ...pi[si], dvp: [..._slice(pi[si].dvp, 0, ti), fp, ..._slice(pi[si].dvp, ti + 1)] },
      ..._slice(pi, si + 1)
    ]
  }

  dispatch({
    type: LB_FINISH_KILL_USER_TOKEN,
    movingKukari: null,
    pi
  })
}

export function resetScoreFlyAnimationConfigForToken(playerNumber: PLAYER_NUMBER) {
  return {
    type: LB_RESET_SCORE_FLY_ANIMATION_CONFIG,
    playerNumber
  };
}


export function showGameEndNudge() {
  dispatch({
    type: LB_SHOW_GAME_END_NUDGE
  })
}

export function hideGameEndNudge() {
  dispatch({
    type: LB_HIDE_GAME_END_NUDGE
  })
}

export function toggleLastMove(playerNames?: Array<string>) {
  dispatch({
    type: LB_TOGGLE_LAST_MOVE,
    finalMovePlayers: playerNames || null
  })
}

export function handleLeaveGame() {
  sendEvents({
    name: CLEVERTAP_EVENTS.EVENT_LEAVE_TABLE,
    params: {
      [CT_PARAMS.SERIAL_NUMBER]: getSerialNumber(getState()),
      [CT_PARAMS.USERNAME]: getUsername(getState())
    }
  })
  emit(
    parseString({
      en: 'LT',
      data: {
        OnSeat: 1,
        client_left: 1,
        uid: getUserId(getState()),
        si: getMySeatIndex(getState()),
        reason: 'manually'
      }
    })
  )
}
export function toggleCoinAnimation() {
  return dispatch({
    type: LB_TOGGLE_COIN_ANIMATION
  });
}

export function showGameStartNudge() {
  return dispatch({
    type: LB_SHOW_GAME_START_NUDGE
  });
}

export function hideGameStartNudge() {
  return dispatch({
    type: LB_HIDE_GAME_START_NUDGE
  });
}

export async function getProfilePicture2P(url?: string | null) {
  if (_isEmpty(url)) {
    return '';
  }
  if (_startsWith(url as string, 'https')) {
    return url as string
  }
  // const { rabu } = await fetchPostSignupConfig()
  // return `${rabu}${url}`
}